interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="52"
    viewBox="0 0 67 52"
    fill="none"
  >
    <path
      d="M55.0039 24.9397V3.90179C55.0039 2.29743 53.7065 1 52.1021 1H3.90179C2.29743 1 1 2.29743 1 3.90179V41.5413C1 43.5363 2.6183 45.1546 4.61328 45.1546H38.4582"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25446 5.93876C8.25446 5.65974 8.03125 5.43652 7.75223 5.43652C7.47321 5.43652 7.25 5.65974 7.25 5.93876C7.25 6.21777 7.47321 6.44099 7.75223 6.44099C8.03125 6.44099 8.25446 6.21777 8.25446 5.93876Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0435 5.93876C14.0435 5.65974 13.8203 5.43652 13.5413 5.43652C13.2623 5.43652 13.0391 5.65974 13.0391 5.93876C13.0391 6.21777 13.2623 6.44099 13.5413 6.44099C13.8203 6.44099 14.0435 6.21777 14.0435 5.93876Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8336 5.93876C19.8336 5.65974 19.6104 5.43652 19.3313 5.43652C19.0523 5.43652 18.8291 5.65974 18.8291 5.93876C18.8291 6.21777 19.0523 6.44099 19.3313 6.44099C19.6104 6.44099 19.8336 6.21777 19.8336 5.93876Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10.9326H55.0039"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8525 46.7313L41.458 51.0003V32.5014C41.458 29.9763 43.4948 27.9395 46.02 27.9395H61.5892C64.1143 27.9395 66.1511 29.9763 66.1511 32.5014V42.1694C66.1511 44.6945 64.1143 46.7313 61.5892 46.7313H45.8665H45.8525Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9912 34.7471H58.9103"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9912 39.4766H58.9103"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVG;
